export type InterviewSimulationsDetailsTranslation = {
  answer: string;
  buttons: {
    send: string;
  };
  knowMe: string;
  typeMessage: string;
};

export const interviewSimulationsDetailsTranslation: InterviewSimulationsDetailsTranslation = {
  answer: 'Answer',
  buttons: {
    send: 'Send',
  },
  knowMe: 'KnowMe',
  typeMessage: 'Type an answer...',
};
